export default __webpack_public_path__ + "static/media/Hayley-Wahlroos.dc109a68.pdf";